import NewStoreBookoutItem from "../bookout_items/mobile/new";
import StoreHome from "./home";
import StoreBookoutItemsIndex from "modules/store/bookout_items/mobile/index.jsx";
import StoreOverallsIndex from "modules/store/overalls/mobile/index";
import NewStoreOverall from "modules/store/overalls/mobile/new";
import EditStoreOveralls from "../overalls/mobile/edit";
import StoreRequestsIndex from "modules/store/requests/mobile/index";
import NewStoreRequest from "modules/store/requests/mobile/new";

let routes = [];

routes.push({
  path: "/store/requests/new",
  component: NewStoreRequest,
  name: "New Store Request",
});
routes.push({
  path: "/store/requests",
  component: StoreRequestsIndex,
  name: "Store Requests",
});

routes.push({
  path: "/store/bookout_items/new",
  component: NewStoreBookoutItem,
  name: "New Bookout",
});
routes.push({
  path: "/store/bookout_items",
  component: StoreBookoutItemsIndex,
  name: "Store Bookout Items",
});

routes.push({ path: "/store/overalls/:id/edit", component: EditStoreOveralls, name: "Edit StoreOverall" });

routes.push({
  path: "/store/overalls/new",
  component: NewStoreOverall,
  name: "Store Bookout Items",
});
routes.push({
  path: "/store/overalls",
  component: StoreOverallsIndex,
  name: "Store Bookout Items",
});

routes.push({
  path: "/store",
  component: StoreHome,
  name: "Store Home",
});

export default routes;
